import { httpAuthRequest } from '@/services'


const state = {
  documents: [],
  compulsoryDocuments: []
}

const actions = {
  async getDocuments({ commit }) {
    const response = await httpAuthRequest('get', '/documents/')
    if (response.success) commit('SET_DOCUMENTS', response.data)
    return response.success
  },

  async getCompulsoryDocuments({ commit }) {
    const response = await httpAuthRequest('get', '/documentsdownload/')
    if (response.success) commit('SET_COMPULSORY_DOCUMENTS', response.data)
    return response.success
  },

}

const mutations = {
  SET_DOCUMENTS(state, documents) {
    state.documents = documents.results
  },

  SET_COMPULSORY_DOCUMENTS(state, documents) {
    state.compulsoryDocuments = documents.results
  },

  RESET_STATE(state) {
    state.documents = [];
    state.compulsoryDocuments = [];
  },
}

export default {
  state,
  actions,
  mutations
}
